import { render, staticRenderFns } from "./UserCompetitionCard.vue?vue&type=template&id=aa153740&"
import script from "./UserCompetitionCard.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports